import { Icon } from "@utp/react-components-prod";
import { Statuses, TStatus } from "utils/InterfaceAndTypeGeneral";

interface ITagStatusProps {
  type: TStatus;
}
const TagStatus = ({ type }: ITagStatusProps) => {
  const getIcon = () => {
    switch (type) {
      case Statuses.NOT_DELIVERED:
        return "alert-circle";
      case Statuses.IN_PROGRESS:
        return "edit";
      case Statuses.OUT_OF_DATE:
        return "x";
      case Statuses.FINISHED:
        return "check";
      default:
        return "";
    }
  };
  const getStatus = () => {
    switch (type) {
      case Statuses.NOT_DELIVERED:
        return "Por rendir";
      case Statuses.IN_PROGRESS:
        return "Rindiendo";
      case Statuses.OUT_OF_DATE:
        return "No rendido";
      case Statuses.FINISHED:
        return "Rendido";
      default:
        return "";
    }
  };

  const getColorBg = () => {
    switch (type) {
      case Statuses.NOT_DELIVERED:
        return "bg-golden-20 text-golden-70 border-golden-70";
      case Statuses.IN_PROGRESS:
        return "bg-cyan-20 text-cyan-60 border-cyan-60";
      case Statuses.OUT_OF_DATE:
        return "bg-mid-grey-20 text-mid-grey-70 border-mid-grey-70";
      case Statuses.FINISHED:
        return "bg-green-20 text-green-70";
      default:
        return "color-02";
    }
  };

  return (
    <div
      className={`flex items-center flex-shrink-0 w-fit py-1 px-2 rounded-lg font-bold text-small-02 order-solid border  ${getColorBg()} ${
        type === Statuses.OTHER ? "hidden" : ""
      }`}
      data-testid="tag-status"
    >
      <Icon iconName={getIcon()} size={16} className="mr-2" />
      <span className="text-small-02">{getStatus()}</span>
    </div>
  );
};

export default TagStatus;
